import React, { useContext, useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { auth, logout } from "../firebase/firebase";
import classes from "../Signup/Signup.module.css";
import {
  getMultiFactorResolver,
  multiFactor,
  PhoneAuthProvider,
  PhoneMultiFactorGenerator,
  RecaptchaVerifier,
  sendEmailVerification,
  signInWithEmailAndPassword,
  signInWithCustomToken,
} from "firebase/auth";
import "react-phone-number-input/style.css";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import OtpInput from "./OtpInput";
import { toast } from "react-toastify";
import Loader from "../Loader";
import { Activity, currentRequestTimeStamp, resolveScreenParam } from "../../Constants";
import { useMixPanelForTracking } from "../../utils/TrackMixPanel";
import { UserApiContext } from "../UserDetailsContext/UserDetailsContext";
import { MyCompanyProfileContext } from "../../MyCompanyProfileContext";
import { Urls } from "../../Urls";
import Axios from "../../Axios";
import axios from "axios";
import { MFA_VERIFIED_KEY } from "../App";
import AuthLeftPanel from "../AuthLeftPanel/AuthLeftPanel";
import VerifyEmailScreen from "../Shared/VerifyEmailScreen";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [show, setshow] = useState(false);
  const [rememberMe, setRemember] = useState(false);
  const [rememberDuration, setRememberDuration] = useState(14);
  const { userDetails } = useContext(UserApiContext);
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const history = useHistory();
  const location = useLocation();
  const [passwordVisible, setpasswordVisible] = useState(false);
  const [ipAddress, setIpAddress] = useState("");
  // rightView values: "login" | "mfa" | "verify-email"
  const [rightView, setRightView] = useState("login");

  const [usedTwoFA, setUsedTwoFA] = useState(false);
  const [challengeOtp, setChallengeOtp] = useState("");
  const [challengeOtpSent, setChallengeOtpSent] = useState(false);
  const [challengeLoading, setChallengeLoading] = useState(false);
  const [recaptchaKey, setRecaptchaKey] = useState(0);

  // MFA setup only happens from Company Profile settings, not from login.
  // const [setupPhone, setSetupPhone]                  = useState("");
  // const [setupOtp, setSetupOtp]                      = useState("");
  // const [setupVerificationId, setSetupVerificationId]= useState(null);
  // const [setupLoading, setSetupLoading]              = useState(false);
  // const setupRecaptchaRef                            = useRef(null);

  const mfaResolverRef = useRef(null);
  const challengeVerifIdRef = useRef("");
  const challengeRecaptchaRef = useRef(null);

  const { TrackMixPanel } = useMixPanelForTracking(userDetails, companySettingData);

  useEffect(() => {
    axios.get("https://api.ipify.org?format=json").then((res) => {
      sessionStorage.setItem("ClientIP", res.data.ip);
      setIpAddress(res.data.ip);
    });
  }, []);

  const getOrCreateRecaptcha = (containerId, ref) => {
    if (ref.current) return ref.current;
    try {
      ref.current = new RecaptchaVerifier(auth, containerId, {
        size: "invisible",
        "expired-callback": () => {
          toast.warn("Security check expired. Please try again.");
          clearRecaptcha(ref, containerId);
        },
      });
      return ref.current;
    } catch (e) {
      console.error("reCAPTCHA init error:", e);
      return null;
    }
  };

  const clearRecaptcha = (ref, containerId) => {
    try { ref.current?.clear(); } catch (_) { }
    ref.current = null;
    const el = document.getElementById(containerId);
    if (el) el.innerHTML = "";
  };

  const handleEmailChange = (e) => {
    if (e.target.value.length <= 50) setEmail(e.target.value.toLowerCase());
    else toast.warn("Email cannot exceed 50 characters.");
  };

  const handleToggle = () => setpasswordVisible((v) => !v);
  const validateEmail = (v) => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v);
  const signup = () => history.push("/signup");
  const redirect = () => history.push("/forgot-password");

  const goBackToLogin = () => {
    TrackMixPanel({
      ModuleName: "MFA",
      ScreenName: "login",
      Data: ``,
      Definition: "User went back to login from MFA challenge screen",
    });
    clearRecaptcha(challengeRecaptchaRef, "recaptcha-container-challenge");
    setRecaptchaKey((k) => k + 1);
    mfaResolverRef.current = null;
    challengeVerifIdRef.current = "";
    setRightView("login");
    setChallengeOtp(""); setChallengeOtpSent(false); setChallengeLoading(false);
    setError("");
    setshow(false);
    localStorage.removeItem(MFA_VERIFIED_KEY);
    logout(auth);
  };

//   const handleSuccessfulLogin = async (isMfa = false, firstTime = false) => {
//     try {
//       clearRecaptcha(challengeRecaptchaRef, "recaptcha-container-challenge");
//       // TODO: POST SPRINT 2 — also clear setup recaptcha when re-enabled
//       // clearRecaptcha(setupRecaptchaRef, "recaptcha-container-setup");

//       const user = auth.currentUser;
//       if (!user) { setshow(false); toast.error("Authentication failed. Please try again."); return; }

//       await user.reload();
//       await user.getIdToken(true);

//       try {
//         Activity(
//           [{ screen: "sign in", module: "login", user_activity: "Logged in successfully", timestamp: currentRequestTimeStamp() }],
//           "Sign-In", email, "", "", ipAddress
//         );
//       } catch (actErr) { console.warn("Activity logging failed", actErr); }

//       if (rememberMe) {
//         try { await Axios.post(Urls.rememberDevice, {}, { withCredentials: true }); }
//         catch (remErr) { console.warn("Could not remember device:", remErr); }
//       }

//       if (isMfa || usedTwoFA) {
//         try { await Axios.post(Urls.user_data, { firstTimeUser: false, ip: ipAddress }); }
//         catch (e) { console.log(e); }
//       }

//       localStorage.setItem(MFA_VERIFIED_KEY, "true");
//       // const matchedRoute = resolveScreenParam(location.search);
//       // history.push(matchedRoute ? `/${matchedRoute}` : '/');
//       const currentPath = window.location.pathname;
//       const currentSearch = window.location.search;

//       if (currentPath && currentPath !== "/" && currentPath !== "/login") {
//         history.push(currentPath + currentSearch);
//       } else {
//         history.push("/");
//       }
// //       const currentPath = window.location.pathname;
// // const currentSearch = window.location.search;

// // if (currentPath && currentPath !== "/" && currentPath !== "/login") {
// //   window.location.href = currentPath + currentSearch;
// // } else {
// //   window.location.href = "/";
// // }

//     } catch (e) {
//       console.error("handleSuccessfulLogin error:", e);
//       setshow(false);
//       toast.error("Navigation failed. Please refresh and try again.");
//     }
//   };

const handleSuccessfulLogin = async (isMfa = false, firstTime = false) => {
    try {
      clearRecaptcha(challengeRecaptchaRef, "recaptcha-container-challenge");
      // TODO: POST SPRINT 2 — also clear setup recaptcha when re-enabled
      // clearRecaptcha(setupRecaptchaRef, "recaptcha-container-setup");

      const user = auth.currentUser;
      if (!user) { setshow(false); toast.error("Authentication failed. Please try again."); return; }

      await user.reload();
      await user.getIdToken(true);

      try {
        Activity(
          [{ screen: "sign in", module: "login", user_activity: "Logged in successfully", timestamp: currentRequestTimeStamp() }],
          "Sign-In", email, "", "", ipAddress
        );
      } catch (actErr) { console.warn("Activity logging failed", actErr); }

      if (rememberMe) {
        try { await Axios.post(Urls.rememberDevice, {}, { withCredentials: true }); }
        catch (remErr) { console.warn("Could not remember device:", remErr); }
      }

      if (isMfa || usedTwoFA) {
        try { await Axios.post(Urls.user_data, { firstTimeUser: false, ip: ipAddress }); }
        catch (e) { console.log(e); }
      }

      // localStorage.setItem(MFA_VERIFIED_KEY, "true");
      // // const matchedRoute = resolveScreenParam(location.search);
      // // history.push(matchedRoute ? `/${matchedRoute}` : '/');
      // const currentPath = window.location.pathname;
      // const currentSearch = window.location.search;

      // setshow(false);

      // if (currentPath && currentPath !== "/" && currentPath !== "/login") {
      //   history.push(currentPath + currentSearch);
      // } else {
      //   history.push("/");
      // }

 localStorage.setItem(MFA_VERIFIED_KEY, "true");
      window.dispatchEvent(new Event("lorri:force-auth-in"));
      setshow(true);
      // const matchedRoute = resolveScreenParam(location.search);
      // history.push(matchedRoute ? `/${matchedRoute}` : '/');
      const currentPath = window.location.pathname;
      const currentSearch = window.location.search;

      if (currentPath && currentPath !== "/" && currentPath !== "/login") {
        history.push(currentPath + currentSearch);
      } else {
        history.push("/");
      }
    } catch (e) {
      console.error("handleSuccessfulLogin error:", e);
      setshow(false);
      toast.error("Navigation failed. Please refresh and try again.");
    }
  };
  const submit = async (e) => {
    e.preventDefault();

    if (!validateEmail(email)) { toast.info("Invalid email format."); return; }
    if (email.length > 50) { toast.info("Email cannot exceed 50 characters."); return; }
    if (password.length > 25) { toast.info("Password cannot exceed 25 characters."); return; }

    setshow(true);
    setError("");

    TrackMixPanel({
      ModuleName: "lorri header", ScreenName: "user profile",
      Data: `email : ${email}`, Definition: "user has clicked on sign in button", optionalData: email,
    });

    try {
      await signInWithEmailAndPassword(auth, email, password);
      const user = auth.currentUser;

      // MFA users are guaranteed to have a verified email (MFA setup requires it),
      // so we only run the email-verified check for non-MFA users here.
      if (!user.emailVerified) {
        // Send a fresh verification email so the user can act immediately
        try {
          await sendEmailVerification(user);
        } catch (sendErr) {
          // Non-fatal — the screen still shows; user can resend manually
          console.warn("[Login] sendEmailVerification failed:", sendErr);
        }
        setshow(false);
        setRightView("verify-email");
        return;
      }

      localStorage.setItem(MFA_VERIFIED_KEY, "true");

      await handleSuccessfulLogin();

    } catch (err) {
      console.error("submit error:", err);

      if (err.code === "auth/multi-factor-auth-required") {
        // MFA users have verified emails — skip email check, go straight to MFA challenge
        setshow(false);

        try {
          const resp = await axios.post(Urls.preLogin, { email }, { withCredentials: true });

          if (resp?.data?.trusted && resp?.data?.customToken) {
            localStorage.setItem(MFA_VERIFIED_KEY, "true");
            setshow(true);
            await signInWithCustomToken(auth, resp.data.customToken);
            await handleSuccessfulLogin();
            return;
          }

          if (resp?.data?.remember_duration) {
            setRememberDuration(resp.data.remember_duration);
          }
        } catch (preErr) {
          console.warn("Pre-login check bypassed:", preErr);
          localStorage.removeItem(MFA_VERIFIED_KEY);
        }

        mfaResolverRef.current = getMultiFactorResolver(auth, err);
        setRightView("mfa");
        return;
      }

      if (err.code === "auth/user-not-found") setError("User does not exist. Please Sign Up!");
      else if (err.code === "auth/wrong-password") setError("The password is incorrect!");
      else if (err.code === "auth/invalid-credential") setError("Incorrect email or password.");
      else if (err.code === "auth/invalid-email") setError("The email address is not valid.");
      else if (err.code === "auth/too-many-requests") setError("Too many attempts. Please try again later.");
      else if (err.code === "auth/user-disabled") setError("This account has been disabled.");
      else setError("Sign-in failed. Please check your credentials and try again.");

      setshow(false);
    }
  };

  // TODO: POST SPRINT 2 — re-enable email verification view handlers after demos
  // const checkEmailVerified = async () => { ... };
  // const resendVerificationEmail = async () => { ... };

  const sendRecoveryMail = async () => {
    if (!email) { toast.info("Please enter your email first."); return; }
    setshow(true);
    try {
      const { data } = await Axios.post(Urls.PhoneRecovery, { email });
      if (data.status === true || data.status === "true" || data.status === 200) {
        toast.success("MFA recovery instructions sent to your email!");

        TrackMixPanel({
          ModuleName: "MFA",
          ScreenName: "login",
          Data: `email: ${email}`,
          Definition: "User requested MFA phone number recovery email",
        });
      }

      else
        toast.error(data.message || "Failed to send recovery email.");
    } catch {
      toast.error("Could not send recovery email. Please check your connection.");
    } finally { setshow(false); }
  };

  const sendChallengeOtp = async () => {
    if (!mfaResolverRef.current || challengeLoading) return;
    setChallengeLoading(true);

    const phoneHint = mfaResolverRef.current.hints.find(
      (h) => h.factorId === PhoneMultiFactorGenerator.FACTOR_ID
    );
    if (!phoneHint) {
      toast.error("No phone factor found for this account.");
      setChallengeLoading(false);
      return;
    }

    try {
      const recaptcha = getOrCreateRecaptcha("recaptcha-container-challenge", challengeRecaptchaRef);
      if (!recaptcha) throw new Error("reCAPTCHA not ready.");

      const provider = new PhoneAuthProvider(auth);
      const verificationId = await provider.verifyPhoneNumber(
        { multiFactorHint: phoneHint, session: mfaResolverRef.current.session },
        recaptcha
      );

      challengeVerifIdRef.current = verificationId;
      setChallengeOtpSent(true);
      TrackMixPanel({
        ModuleName: "MFA",
        ScreenName: "login",
        Data: `email: ${email}`,
        Definition: "User requested MFA OTP during login challenge",
      });
      toast.success("Security code sent!");
    } catch (e) {
      console.error("sendChallengeOtp error:", e);
      clearRecaptcha(challengeRecaptchaRef, "recaptcha-container-challenge");
      const msg = (e.message || e.code || "").toUpperCase();
      if (msg.includes("INVALID-APP-CREDENTIAL") || msg.includes("CAPTCHA")) {
        toast.error("Security check failed. Please try again.");
      } else {
        toast.error(e.message || "Failed to send OTP. Please try again.");
      }
    } finally {
      setChallengeLoading(false);
    }
  };

  const verifyChallengeOtp = async () => {
    if (!challengeOtp.trim() || challengeOtp.length < 6) {
      toast.info("Please enter the full 6-digit OTP.");
      return;
    }
    if (!challengeVerifIdRef.current) {
      toast.error("Session expired. Please resend the code.");
      return;
    }

    setChallengeLoading(true);
    try {
      const cred = PhoneAuthProvider.credential(challengeVerifIdRef.current, challengeOtp);
      const assertion = PhoneMultiFactorGenerator.assertion(cred);
      await mfaResolverRef.current.resolveSignIn(assertion);
      setUsedTwoFA(true);
      setChallengeLoading(false);
      setshow(false);
      TrackMixPanel({
        ModuleName: "MFA",
        ScreenName: "login",
        Data: `email: ${email}`,
        Definition: "User successfully verified MFA OTP during login",
      });
      await handleSuccessfulLogin(true, false);
    } catch (e) {
      console.error("verifyChallengeOtp error:", e);
      TrackMixPanel({
        ModuleName: "MFA",
        ScreenName: "login",
        Data: `email: ${email}, error: ${e.code}`,
        Definition: "User entered invalid MFA OTP during login",
      });
      setChallengeLoading(false);
      setChallengeOtp("");
      if (e.code === "auth/invalid-verification-code") {
        toast.error("Invalid OTP. Please try again.");
      } else if (e.code === "auth/session-expired" || e.code === "auth/credential-too-old-login-again") {
        toast.error("Session expired. Please sign in again.");
        goBackToLogin();
      } else {
        toast.error(e.message || "Verification failed. Please try again.");
      }
    }
  };

  // TODO: POST SPRINT 2 — re-enable MFA setup flow on login when needed
  // const sendSetupOtp = async () => { ... };
  // const verifySetupOtp = async () => { ... };

  const renderRightSide = () => {

    // TODO: POST SPRINT 2 — re-enable mfa-setup view on login after demos
    // if (rightView === "mfa-setup") { ... }

    if (rightView === "mfa") {
      const resolver = mfaResolverRef.current;
      const phoneHint = resolver?.hints?.find((h) => h.factorId === PhoneMultiFactorGenerator.FACTOR_ID);
      const displayPhone = phoneHint?.phoneNumber || "your registered number";

      return (
        <div className={classes["signup-card"]}>
          <div style={{ background: "#39318510", color: "#393185", width: 60, height: 60, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px" }}>
            <i className="fa fa-shield-alt" style={{ fontSize: 24 }}></i>
          </div>
          <div className={classes["signup-card-header"]} style={{ textAlign: "center", marginBottom: "12px" }}>
            Two-Factor Authentication
          </div>
          <p style={{ fontSize: "14px", color: "#6b7280", marginBottom: "24px", lineHeight: "1.5", textAlign: "center" }}>
            {challengeOtpSent
              ? <>We've sent a 6-digit code to <strong>{displayPhone}</strong>.</>
              : <>We'll send a security code to your phone ending in <strong>{displayPhone}</strong>.</>}
          </p>

          <div key={recaptchaKey} id="recaptcha-container-challenge" style={{ marginBottom: 20, display: "flex", justifyContent: "center" }} />

          {!challengeOtpSent ? (
            <>
              <button className={classes["submit-btn"]} onClick={sendChallengeOtp} disabled={challengeLoading}>
                {challengeLoading ? "Sending OTP..." : "Send Security Code"}
              </button>
              <div className={classes["login-link-container"]} style={{ marginTop: "16px", justifyContent: "center" }}>
                <span className={classes["login-link"]} onClick={sendRecoveryMail} style={{ opacity: challengeLoading ? 0.6 : 1 }}>
                  Lost access to your phone? Reset phone number
                </span>
              </div>
            </>
          ) : (
            <div style={{ width: "100%" }}>
              <OtpInput value={challengeOtp} onChange={setChallengeOtp} onEnter={() => { setUsedTwoFA(true); verifyChallengeOtp(); }} />

              <div className="d-flex align-items-center justify-content-center" style={{ marginTop: "24px", marginBottom: "24px", cursor: "pointer" }} onClick={() => setRemember((v) => !v)}>
                <input type="checkbox" id="rememberMe" checked={rememberMe} readOnly style={{ width: 16, height: 16, cursor: "pointer", accentColor: "var(--purple-700)", margin: 0 }} />
                <label htmlFor="rememberMe" style={{ fontSize: 13, color: "#4b5563", fontWeight: 600, cursor: "pointer", margin: "0 0 0 10px" }}>
                  Remember this device for {rememberDuration} days
                </label>
              </div>

              <button className={classes["submit-btn"]} onClick={() => { setUsedTwoFA(true); verifyChallengeOtp(); }} disabled={challengeLoading}>
                {challengeLoading ? "Verifying..." : "Verify & Sign In"}
              </button>

              <div className={classes["login-link-container"]} style={{ marginTop: "16px", justifyContent: "center" }}>
                <span className={classes["login-link"]} onClick={() => { setChallengeOtp(""); setChallengeOtpSent(false); challengeVerifIdRef.current = ""; clearRecaptcha(challengeRecaptchaRef, "recaptcha-container-challenge"); setRecaptchaKey(k => k + 1); }}>
                  Didn't receive code? Resend OTP
                </span>
              </div>
            </div>
          )}

          <div className={classes["login-link-container"]} style={{ marginTop: "24px", borderTop: "1px solid #e5e7eb", paddingTop: "20px" }}>
            <span className={classes["login-link"]} onClick={goBackToLogin}>
              <i className="fa fa-arrow-left" style={{ marginRight: "6px" }}></i> Back to Sign In
            </span>
          </div>
        </div>
      );
    }

    return (
      <div className={classes["signup-card"]}>
        <div className={classes["signup-card-header"]}>
          <span className={classes["highlight-blue"]}>Sign in to get started</span>
        </div>

        <div className={classes["form-label"]}>Email Address</div>
        <div className={classes["input-group"]}>
          <i className={`far fa-envelope ${classes["input-icon"]}`}></i>
          <input className={classes["input-field"]} value={email} onChange={handleEmailChange}
            placeholder="Enter email address" type="email" />
        </div>

        <div className={classes["form-label"]}>Password</div>
        <div className={classes["input-group"]}>
          <i className={`fas fa-lock ${classes["input-icon"]}`}></i>
          <input className={classes["input-field"]} value={password}
            onChange={(e) => { if (e.target.value.length <= 25) setPassword(e.target.value); else toast.warn("Password cannot exceed 25 characters."); }}
            placeholder="Enter password" type={passwordVisible ? "text" : "password"}
            onKeyPress={(e) => { if (e.key === "Enter") submit(e); }} />
          <span onClick={handleToggle} className={classes["toggle-password"]}>
            <i className={passwordVisible ? "far fa-eye-slash" : "far fa-eye"}></i>
          </span>
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 16, marginTop: 4 }}>
          <span onClick={redirect} style={{ fontSize: 12, color: "var(--purple-700)", fontWeight: 600, cursor: "pointer" }}>
            Forgot password?
          </span>
        </div>

        {error && (
          <div className={classes["error-container"]}>
            <div className={classes["error-message"]}>{error}</div>
          </div>
        )}

        <button className={classes["submit-btn"]} onClick={submit}>Sign In</button>

        <div className={classes["login-link-container"]}>
          Don't have an account?{" "}
          <button className={classes["login-link"]} onClick={signup}>Sign Up Now!</button>
        </div>
      </div>
    );
  };

  // verify-email view renders VerifyEmailScreen inside the same two-column layout
  if (rightView === "verify-email") {
    return (
      <div className={classes["master-container"]}>
        <Loader show={show} />
        <div style={{ width: "100vw" }} className={`row position-relative m-0 ${classes["main-row"]}`}>
          <AuthLeftPanel />
          <div className={`col-md-6 ${classes["column-add"]} p-0`}>
            <VerifyEmailScreen
              email={email}
              // onVerified={async () => {
              //   setshow(true);
              //   await handleSuccessfulLogin();
              // }}
              onVerified={async () => {
  await handleSuccessfulLogin();
}}
              onBack={goBackToLogin}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={classes["master-container"]}>
      <Loader show={show} />
      <div style={{ width: "100vw" }} className={`row position-relative m-0 ${classes["main-row"]}`}>
        <AuthLeftPanel />
        <div className={`col-md-6 ${classes["column-add"]} p-0`}>
          <div className={classes["right-content-wrapper"]}>
            <div className={classes["right-logo-container"]}>
              <img className={classes["right-logo"]} src={Urls.LorriLogoLogin} alt="Lorri Logo" />
            </div>
            {renderRightSide()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;